var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('white-blue-button',{staticClass:"clr-co hvr-bg-red hvr-clr-red rounded-xl btn-neumo bsd bc-wht bw-02r",class:_vm.css_class,attrs:{"title":"日報を見る"},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('ReportIcon')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }